import { SamplePointWithHeaterAddOn } from 'types/models/heater';
import SamplePoint, { SamplePointId } from 'types/models/samplePoint';
import { checkIsHeaterHost } from 'utils/associated-sample-points/check-is-heater-host';

/**
 * Finds the host sample point that contains the given nested heater sensor.
 * Returns undefined if no host contains this heater sensor.
 */
export const findHeaterHostForSamplePoint = (
  topLevelSamplePoints: SamplePoint[],
  nestedSamplePointId: SamplePointId
): SamplePoint | undefined => {
  const heaterHosts = topLevelSamplePoints.filter(checkIsHeaterHost);

  return heaterHosts.find(host => {
    const heaterAddOn = (host as SamplePointWithHeaterAddOn)._hidden?.heater;
    if (!heaterAddOn) return false;

    // Check if nestedSamplePointId matches any of the nested heater sample point IDs
    return Object.values(heaterAddOn).includes(nestedSamplePointId);
  });
};

/**
 * Checks if a sample point ID belongs to a heater host.
 */
export const hasHeaterHost = (
  topLevelSamplePoints: SamplePoint[],
  nestedSamplePointId: SamplePointId
): boolean => {
  return findHeaterHostForSamplePoint(topLevelSamplePoints, nestedSamplePointId) !== undefined;
};
